const StatusMessage = ({ error, empty }: { error?: string | null; empty?: boolean }) => {
  if (error) return <div className="rounded bg-red-50 text-red-700 px-4 py-3 text-sm">{error}</div>;
  if (empty) return <div className="text-gray-500 text-sm py-6 text-center">No data.</div>;
  return null;
};
export default StatusMessage;
